import loadingLottie from "@/assets/v2/loading.json";

import { LottieOptions, useLottie } from "lottie-react";

import { cn } from "@shared/utils/cn";

export const Loader: React.FC<Partial<LottieOptions<"svg">>> = (props) => {
  const options: LottieOptions<"svg"> = {
    loop: true,
    autoplay: true,
    animationData: loadingLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
    ...props,
    className: cn("size-32 mx-auto", props.className),
  };
  const { View } = useLottie(options);

  return <>{View}</>;
};
